
import { ALMData } from '../types';

// Sample data for the ALM Dashboard with realistic Indian NBFC values
export const defaultAlmData: ALMData = {
  assets: [
    {
      name: "Cash and Bank",
      values: {
        // Month horizons
        h1: 302000000,      // ₹30.2 crore
        h2: 282000000,      // ₹28.2 crore - decreasing to show deficit
        h3: 252000000,      // ₹25.2 crore - decreasing to show deficit
        h4: 232000000,      // ₹23.2 crore - decreasing to show deficit
        h5: 212000000,      // ₹21.2 crore - decreasing to show deficit
        // Day horizons
        d1: 307000000,      // ₹30.7 crore
        d3: 305000000,      // ₹30.5 crore
        d7: 300000000,      // ₹30 crore
        d15: 297000000,     // ₹29.7 crore
        d30: 302000000      // ₹30.2 crore
      }
    },
    {
      name: "Current Accounts",
      values: {
        // Month horizons
        h1: 87000000,       // ₹8.7 crore
        h2: 75000000,       // ₹7.5 crore - decreasing to show deficit
        h3: 65000000,       // ₹6.5 crore - decreasing to show deficit
        h4: 55000000,       // ₹5.5 crore - decreasing to show deficit
        h5: 45000000,       // ₹4.5 crore - decreasing to show deficit
        // Day horizons
        d1: 88000000,       // ₹8.8 crore
        d3: 87500000,       // ₹8.75 crore
        d7: 87000000,       // ₹8.7 crore
        d15: 86500000,      // ₹8.65 crore
        d30: 87000000       // ₹8.7 crore
      }
    },
    {
      name: "Savings Accounts",
      values: {
        // Month horizons
        h1: 65000000,       // ₹6.5 crore
        h2: 60000000,       // ₹6 crore - decreasing to show deficit
        h3: 55000000,       // ₹5.5 crore - decreasing to show deficit
        h4: 50000000,       // ₹5 crore - decreasing to show deficit
        h5: 45000000,       // ₹4.5 crore - decreasing to show deficit
        // Day horizons
        d1: 66000000,       // ₹6.6 crore
        d3: 65700000,       // ₹6.57 crore
        d7: 65400000,       // ₹6.54 crore
        d15: 65200000,      // ₹6.52 crore
        d30: 65000000       // ₹6.5 crore
      }
    },
    {
      name: "Fixed Deposits",
      values: {
        // Month horizons
        h1: 500000000,      // ₹50 crore
        h2: 480000000,      // ₹48 crore
        h3: 450000000,      // ₹45 crore
        h4: 430000000,      // ₹43 crore
        h5: 400000000,      // ₹40 crore
        // Day horizons
        d1: 500000000,      // ₹50 crore
        d3: 500000000,      // ₹50 crore
        d7: 500000000,      // ₹50 crore
        d15: 500000000,     // ₹50 crore
        d30: 500000000      // ₹50 crore
      }
    },
    {
      name: "Bank FDs",
      values: {
        // Month horizons
        h1: 320000000,      // ₹32 crore
        h2: 310000000,      // ₹31 crore
        h3: 300000000,      // ₹30 crore
        h4: 290000000,      // ₹29 crore
        h5: 280000000,      // ₹28 crore
        // Day horizons
        d1: 320000000,      // ₹32 crore
        d3: 320000000,      // ₹32 crore
        d7: 320000000,      // ₹32 crore
        d15: 320000000,     // ₹32 crore
        d30: 320000000      // ₹32 crore
      }
    },
    {
      name: "Corporate FDs",
      values: {
        // Month horizons
        h1: 175000000,      // ₹17.5 crore
        h2: 170000000,      // ₹17 crore
        h3: 165000000,      // ₹16.5 crore
        h4: 160000000,      // ₹16 crore
        h5: 155000000,      // ₹15.5 crore
        // Day horizons
        d1: 175000000,      // ₹17.5 crore
        d3: 175000000,      // ₹17.5 crore
        d7: 175000000,      // ₹17.5 crore
        d15: 175000000,     // ₹17.5 crore
        d30: 175000000      // ₹17.5 crore
      }
    },
    {
      name: "Certificate of Deposits",
      values: {
        // Month horizons - ensuring sums match the parent Fixed Deposits
        h1: 5000000,        // ₹0.5 crore
        h2: 0,              // ₹0 crore
        h3: -15000000,      // -₹1.5 crore (reducing balance)
        h4: -20000000,      // -₹2 crore (reducing balance)
        h5: -35000000,      // -₹3.5 crore (reducing balance)
        // Day horizons
        d1: 5000000,        // ₹0.5 crore
        d3: 5000000,        // ₹0.5 crore
        d7: 5000000,        // ₹0.5 crore
        d15: 5000000,       // ₹0.5 crore
        d30: 5000000        // ₹0.5 crore
      }
    },
    {
      name: "Loan Assets",
      values: {
        // Month horizons
        h1: 1300000000,     // ₹130 crore
        h2: 1250000000,     // ₹125 crore
        h3: 1200000000,     // ₹120 crore
        h4: 1150000000,     // ₹115 crore
        h5: 1100000000,     // ₹110 crore
        // Day horizons
        d1: 1305000000,     // ₹130.5 crore
        d3: 1303000000,     // ₹130.3 crore
        d7: 1302000000,     // ₹130.2 crore
        d15: 1301000000,    // ₹130.1 crore
        d30: 1300000000     // ₹130 crore
      }
    },
    {
      name: "Vehicle Loans",
      values: {
        // Month horizons
        h1: 620000000,      // ₹62 crore
        h2: 600000000,      // ₹60 crore
        h3: 580000000,      // ₹58 crore
        h4: 560000000,      // ₹56 crore
        h5: 540000000,      // ₹54 crore
        // Day horizons
        d1: 622000000,      // ₹62.2 crore
        d3: 621000000,      // ₹62.1 crore
        d7: 620500000,      // ₹62.05 crore
        d15: 620200000,     // ₹62.02 crore
        d30: 620000000      // ₹62 crore
      }
    },
    {
      name: "Personal Loans",
      values: {
        // Month horizons
        h1: 280000000,      // ₹28 crore
        h2: 270000000,      // ₹27 crore
        h3: 260000000,      // ₹26 crore
        h4: 250000000,      // ₹25 crore
        h5: 240000000,      // ₹24 crore
        // Day horizons
        d1: 281000000,      // ₹28.1 crore
        d3: 280500000,      // ₹28.05 crore
        d7: 280300000,      // ₹28.03 crore
        d15: 280100000,     // ₹28.01 crore
        d30: 280000000      // ₹28 crore
      }
    },
    {
      name: "SME Loans",
      values: {
        // Month horizons
        h1: 220000000,      // ₹22 crore
        h2: 210000000,      // ₹21 crore
        h3: 200000000,      // ₹20 crore
        h4: 190000000,      // ₹19 crore
        h5: 180000000,      // ₹18 crore
        // Day horizons
        d1: 221000000,      // ₹22.1 crore
        d3: 220500000,      // ₹22.05 crore
        d7: 220200000,      // ₹22.02 crore
        d15: 220100000,     // ₹22.01 crore
        d30: 220000000      // ₹22 crore
      }
    },
    {
      name: "Gold Loans",
      values: {
        // Month horizons
        h1: 180000000,      // ₹18 crore
        h2: 170000000,      // ₹17 crore
        h3: 160000000,      // ₹16 crore
        h4: 150000000,      // ₹15 crore
        h5: 140000000,      // ₹14 crore
        // Day horizons
        d1: 181000000,      // ₹18.1 crore
        d3: 180500000,      // ₹18.05 crore
        d7: 180200000,      // ₹18.02 crore
        d15: 180100000,     // ₹18.01 crore
        d30: 180000000      // ₹18 crore
      }
    }
  ],
  liabilities: [
    {
      name: "Non-Convertible Debentures",
      values: {
        // Month horizons
        h1: 700000000,      // ₹70 crore
        h2: 750000000,      // ₹75 crore - increasing to create deficit
        h3: 800000000,      // ₹80 crore - increasing to create deficit
        h4: 850000000,      // ₹85 crore - increasing to create deficit
        h5: 900000000,      // ₹90 crore - increasing to create deficit
        // Day horizons
        d1: 695000000,      // ₹69.5 crore
        d3: 697000000,      // ₹69.7 crore
        d7: 698000000,      // ₹69.8 crore
        d15: 699000000,     // ₹69.9 crore
        d30: 700000000      // ₹70 crore
      }
    },
    {
      name: "Secured NCDs",
      values: {
        // Month horizons
        h1: 400000000,      // ₹40 crore
        h2: 425000000,      // ₹42.5 crore - increasing to create deficit
        h3: 450000000,      // ₹45 crore - increasing to create deficit
        h4: 475000000,      // ₹47.5 crore - increasing to create deficit
        h5: 500000000,      // ₹50 crore - increasing to create deficit
        // Day horizons
        d1: 398000000,      // ₹39.8 crore
        d3: 399000000,      // ₹39.9 crore
        d7: 399500000,      // ₹39.95 crore
        d15: 399800000,     // ₹39.98 crore
        d30: 400000000      // ₹40 crore
      }
    },
    {
      name: "Unsecured NCDs",
      values: {
        // Month horizons
        h1: 200000000,      // ₹20 crore
        h2: 210000000,      // ₹21 crore - increasing to create deficit
        h3: 220000000,      // ₹22 crore - increasing to create deficit
        h4: 230000000,      // ₹23 crore - increasing to create deficit
        h5: 240000000,      // ₹24 crore - increasing to create deficit
        // Day horizons
        d1: 198000000,      // ₹19.8 crore
        d3: 199000000,      // ₹19.9 crore
        d7: 199500000,      // ₹19.95 crore
        d15: 199800000,     // ₹19.98 crore
        d30: 200000000      // ₹20 crore
      }
    },
    {
      name: "Market Linked NCDs",
      values: {
        // Month horizons
        h1: 100000000,       // ₹10 crore
        h2: 115000000,       // ₹11.5 crore - increasing to create deficit
        h3: 130000000,       // ₹13 crore - increasing to create deficit
        h4: 145000000,       // ₹14.5 crore - increasing to create deficit
        h5: 160000000,       // ₹16 crore - increasing to create deficit
        // Day horizons
        d1: 99000000,        // ₹9.9 crore
        d3: 99500000,        // ₹9.95 crore
        d7: 99800000,        // ₹9.98 crore
        d15: 99900000,       // ₹9.99 crore
        d30: 100000000       // ₹10 crore
      }
    },
    {
      name: "Term Loans",
      values: {
        // Month horizons
        h1: 800000000,      // ₹80 crore
        h2: 820000000,      // ₹82 crore - increasing to create deficit
        h3: 840000000,      // ₹84 crore - increasing to create deficit
        h4: 860000000,      // ₹86 crore - increasing to create deficit
        h5: 880000000,      // ₹88 crore - increasing to create deficit
        // Day horizons
        d1: 798000000,      // ₹79.8 crore
        d3: 799000000,      // ₹79.9 crore
        d7: 799500000,      // ₹79.95 crore
        d15: 799800000,     // ₹79.98 crore
        d30: 800000000      // ₹80 crore
      }
    },
    {
      name: "Bank Term Loans",
      values: {
        // Month horizons
        h1: 450000000,      // ₹45 crore
        h2: 460000000,      // ₹46 crore - increasing to create deficit
        h3: 470000000,      // ₹47 crore - increasing to create deficit
        h4: 480000000,      // ₹48 crore - increasing to create deficit
        h5: 490000000,      // ₹49 crore - increasing to create deficit
        // Day horizons
        d1: 449000000,      // ₹44.9 crore
        d3: 449500000,      // ₹44.95 crore
        d7: 449800000,      // ₹44.98 crore
        d15: 449900000,     // ₹44.99 crore
        d30: 450000000      // ₹45 crore
      }
    },
    {
      name: "NBFC Term Loans",
      values: {
        // Month horizons
        h1: 180000000,      // ₹18 crore
        h2: 185000000,      // ₹18.5 crore - increasing to create deficit
        h3: 190000000,      // ₹19 crore - increasing to create deficit
        h4: 195000000,      // ₹19.5 crore - increasing to create deficit
        h5: 200000000,      // ₹20 crore - increasing to create deficit
        // Day horizons
        d1: 179000000,      // ₹17.9 crore
        d3: 179500000,      // ₹17.95 crore
        d7: 179800000,      // ₹17.98 crore
        d15: 179900000,     // ₹17.99 crore
        d30: 180000000      // ₹18 crore
      }
    },
    {
      name: "External Commercial Borrowings",
      values: {
        // Month horizons
        h1: 120000000,      // ₹12 crore
        h2: 125000000,      // ₹12.5 crore - increasing to create deficit
        h3: 130000000,      // ₹13 crore - increasing to create deficit
        h4: 135000000,      // ₹13.5 crore - increasing to create deficit
        h5: 140000000,      // ₹14 crore - increasing to create deficit
        // Day horizons
        d1: 119000000,      // ₹11.9 crore
        d3: 119500000,      // ₹11.95 crore
        d7: 119800000,      // ₹11.98 crore
        d15: 119900000,     // ₹11.99 crore
        d30: 120000000      // ₹12 crore
      }
    },
    {
      name: "Refinance Loans",
      values: {
        // Month horizons
        h1: 50000000,       // ₹5 crore
        h2: 50000000,       // ₹5 crore - same
        h3: 50000000,       // ₹5 crore - same
        h4: 50000000,       // ₹5 crore - same
        h5: 50000000,       // ₹5 crore - same
        // Day horizons
        d1: 50000000,       // ₹5 crore
        d3: 50000000,       // ₹5 crore
        d7: 50000000,       // ₹5 crore
        d15: 50000000,      // ₹5 crore
        d30: 50000000       // ₹5 crore
      }
    },
    {
      name: "Working Capital Loans",
      values: {
        // Month horizons
        h1: 300000000,      // ₹30 crore
        h2: 315000000,      // ₹31.5 crore - increasing to create deficit
        h3: 330000000,      // ₹33 crore - increasing to create deficit
        h4: 345000000,      // ₹34.5 crore - increasing to create deficit
        h5: 360000000,      // ₹36 crore - increasing to create deficit
        // Day horizons
        d1: 298000000,      // ₹29.8 crore
        d3: 299000000,      // ₹29.9 crore
        d7: 299500000,      // ₹29.95 crore
        d15: 299800000,     // ₹29.98 crore
        d30: 300000000      // ₹30 crore
      }
    },
    {
      name: "Cash Credit",
      values: {
        // Month horizons
        h1: 150000000,      // ₹15 crore
        h2: 155000000,      // ₹15.5 crore - increasing to create deficit
        h3: 160000000,      // ₹16 crore - increasing to create deficit
        h4: 165000000,      // ₹16.5 crore - increasing to create deficit
        h5: 170000000,      // ₹17 crore - increasing to create deficit
        // Day horizons
        d1: 149000000,      // ₹14.9 crore
        d3: 149500000,      // ₹14.95 crore
        d7: 149800000,      // ₹14.98 crore
        d15: 149900000,     // ₹14.99 crore
        d30: 150000000      // ₹15 crore
      }
    },
    {
      name: "Overdraft Facilities",
      values: {
        // Month horizons
        h1: 100000000,      // ₹10 crore
        h2: 105000000,      // ₹10.5 crore - increasing to create deficit
        h3: 110000000,      // ₹11 crore - increasing to create deficit
        h4: 115000000,      // ₹11.5 crore - increasing to create deficit
        h5: 120000000,      // ₹12 crore - increasing to create deficit
        // Day horizons
        d1: 99000000,       // ₹9.9 crore
        d3: 99500000,       // ₹9.95 crore
        d7: 99800000,       // ₹9.98 crore
        d15: 99900000,      // ₹9.99 crore
        d30: 100000000      // ₹10 crore
      }
    },
    {
      name: "Short-term Credit Lines",
      values: {
        // Month horizons
        h1: 50000000,       // ₹5 crore
        h2: 55000000,       // ₹5.5 crore - increasing to create deficit
        h3: 60000000,       // ₹6 crore - increasing to create deficit
        h4: 65000000,       // ₹6.5 crore - increasing to create deficit
        h5: 70000000,       // ₹7 crore - increasing to create deficit
        // Day horizons
        d1: 49000000,       // ₹4.9 crore
        d3: 49500000,       // ₹4.95 crore
        d7: 49800000,       // ₹4.98 crore
        d15: 49900000,      // ₹4.99 crore
        d30: 50000000       // ₹5 crore
      }
    }
  ],
  equity: [
    {
      name: "Share Capital",
      values: {
        // Month horizons
        h1: 500000000,      // ₹50 crore
        h2: 500000000,      // ₹50 crore
        h3: 500000000,      // ₹50 crore
        h4: 500000000,      // ₹50 crore
        h5: 500000000,      // ₹50 crore
        // Day horizons
        d1: 500000000,      // ₹50 crore
        d3: 500000000,      // ₹50 crore
        d7: 500000000,      // ₹50 crore
        d15: 500000000,     // ₹50 crore
        d30: 500000000      // ₹50 crore
      }
    },
    {
      name: "Equity Share Capital",
      values: {
        // Month horizons
        h1: 300000000,      // ₹30 crore
        h2: 300000000,      // ₹30 crore
        h3: 300000000,      // ₹30 crore
        h4: 300000000,      // ₹30 crore
        h5: 300000000,      // ₹30 crore
        // Day horizons
        d1: 300000000,      // ₹30 crore
        d3: 300000000,      // ₹30 crore
        d7: 300000000,      // ₹30 crore
        d15: 300000000,     // ₹30 crore
        d30: 300000000      // ₹30 crore
      }
    },
    {
      name: "Preference Share Capital",
      values: {
        // Month horizons
        h1: 150000000,      // ₹15 crore
        h2: 150000000,      // ₹15 crore
        h3: 150000000,      // ₹15 crore
        h4: 150000000,      // ₹15 crore
        h5: 150000000,      // ₹15 crore
        // Day horizons
        d1: 150000000,      // ₹15 crore
        d3: 150000000,      // ₹15 crore
        d7: 150000000,      // ₹15 crore
        d15: 150000000,     // ₹15 crore
        d30: 150000000      // ₹15 crore
      }
    },
    {
      name: "Compulsory Convertible Debentures",
      values: {
        // Month horizons
        h1: 50000000,       // ₹5 crore
        h2: 50000000,       // ₹5 crore
        h3: 50000000,       // ₹5 crore
        h4: 50000000,       // ₹5 crore
        h5: 50000000,       // ₹5 crore
        // Day horizons
        d1: 50000000,       // ₹5 crore
        d3: 50000000,       // ₹5 crore
        d7: 50000000,       // ₹5 crore
        d15: 50000000,      // ₹5 crore
        d30: 50000000       // ₹5 crore
      }
    },
    {
      name: "Retained Earnings",
      values: {
        // Month horizons
        h1: 200000000,      // ₹20 crore
        h2: 205000000,      // ₹20.5 crore
        h3: 210000000,      // ₹21 crore
        h4: 215000000,      // ₹21.5 crore
        h5: 220000000,      // ₹22 crore
        // Day horizons
        d1: 199000000,      // ₹19.9 crore
        d3: 199500000,      // ₹19.95 crore
        d7: 199800000,      // ₹19.98 crore
        d15: 199900000,     // ₹19.99 crore
        d30: 200000000      // ₹20 crore
      }
    },
    {
      name: "General Reserve",
      values: {
        // Month horizons
        h1: 80000000,       // ₹8 crore
        h2: 82000000,       // ₹8.2 crore
        h3: 84000000,       // ₹8.4 crore
        h4: 86000000,       // ₹8.6 crore
        h5: 88000000,       // ₹8.8 crore
        // Day horizons
        d1: 79500000,       // ₹7.95 crore
        d3: 79800000,       // ₹7.98 crore
        d7: 79900000,       // ₹7.99 crore
        d15: 79950000,      // ₹7.995 crore
        d30: 80000000       // ₹8 crore
      }
    },
    {
      name: "Statutory Reserve",
      values: {
        // Month horizons
        h1: 60000000,       // ₹6 crore
        h2: 61000000,       // ₹6.1 crore
        h3: 62000000,       // ₹6.2 crore
        h4: 63000000,       // ₹6.3 crore
        h5: 64000000,       // ₹6.4 crore
        // Day horizons
        d1: 59500000,       // ₹5.95 crore
        d3: 59800000,       // ₹5.98 crore
        d7: 59900000,       // ₹5.99 crore
        d15: 59950000,      // ₹5.995 crore
        d30: 60000000       // ₹6 crore
      }
    },
    {
      name: "Capital Reserve",
      values: {
        // Month horizons
        h1: 40000000,       // ₹4 crore
        h2: 41000000,       // ₹4.1 crore
        h3: 42000000,       // ₹4.2 crore
        h4: 43000000,       // ₹4.3 crore
        h5: 44000000,       // ₹4.4 crore
        // Day horizons
        d1: 39500000,       // ₹3.95 crore
        d3: 39800000,       // ₹3.98 crore
        d7: 39900000,       // ₹3.99 crore
        d15: 39950000,      // ₹3.995 crore
        d30: 40000000       // ₹4 crore
      }
    },
    {
      name: "Special Reserve",
      values: {
        // Month horizons
        h1: 20000000,       // ₹2 crore
        h2: 20500000,       // ₹2.05 crore
        h3: 21000000,       // ₹2.1 crore
        h4: 21500000,       // ₹2.15 crore
        h5: 22000000,       // ₹2.2 crore
        // Day horizons
        d1: 19500000,       // ₹1.95 crore
        d3: 19800000,       // ₹1.98 crore
        d7: 19900000,       // ₹1.99 crore
        d15: 19950000,      // ₹1.995 crore
        d30: 20000000       // ₹2 crore
      }
    }
  ]
};

// Now adding realistic contract data for the accounts that need more drill-down data

// 1. Current Accounts - Sample detailed accounts
export const currentAccountContracts = [
  {
    id: "ca-101",
    name: "HDFC Bank Current Account",
    type: "Current Account",
    reference: "HDFC3245678901",
    status: "Active",
    bank: "HDFC Bank",
    branch: "Mumbai Main",
    currency: "INR",
    openDate: "2021-05-12",
    balance: 32500000, // ₹3.25 crore
    avgBalance: 31000000, // ₹3.1 crore
    minBalance: 1000000, // ₹10 lakh
    accountType: "Business Current",
    signatories: ["Amit Shah", "Priya Patel"],
    autoSweep: true,
    cashflows: {
      "day-1": 32500000,
      "day-3": 32300000,
      "day-7": 32100000,
      "day-15": 32000000,
      "day-30": 31800000,
      "month-1": 31800000,
      "month-3": 28000000,
      "month-6": 24000000,
      "month-12": 20000000,
      "month-24": 16000000
    }
  },
  {
    id: "ca-102",
    name: "ICICI Bank Current Account",
    type: "Current Account",
    reference: "ICICI4567890123",
    status: "Active",
    bank: "ICICI Bank",
    branch: "Delhi Corporate",
    currency: "INR",
    openDate: "2020-11-03",
    balance: 27500000, // ₹2.75 crore
    avgBalance: 26000000, // ₹2.6 crore
    minBalance: 1000000, // ₹10 lakh
    accountType: "Premium Business",
    signatories: ["Rahul Sharma", "Neha Gupta"],
    autoSweep: true,
    cashflows: {
      "day-1": 27700000,
      "day-3": 27600000,
      "day-7": 27500000,
      "day-15": 27300000,
      "day-30": 27200000,
      "month-1": 27200000,
      "month-3": 23000000,
      "month-6": 20000000,
      "month-12": 17000000,
      "month-24": 14000000
    }
  },
  {
    id: "ca-103",
    name: "Axis Bank Current Account",
    type: "Current Account",
    reference: "AXIS5678901234",
    status: "Active",
    bank: "Axis Bank",
    branch: "Bangalore Tech Park",
    currency: "INR",
    openDate: "2022-02-17",
    balance: 15000000, // ₹1.5 crore
    avgBalance: 14000000, // ₹1.4 crore
    minBalance: 500000, // ₹5 lakh
    accountType: "Corporate Current",
    signatories: ["Suresh Kumar", "Vijay Reddy"],
    autoSweep: false,
    cashflows: {
      "day-1": 15200000,
      "day-3": 15100000,
      "day-7": 15000000,
      "day-15": 14800000,
      "day-30": 14600000,
      "month-1": 14600000,
      "month-3": 12500000,
      "month-6": 10500000,
      "month-12": 9000000,
      "month-24": 7500000
    }
  },
  {
    id: "ca-104",
    name: "SBI Prime Current Account",
    type: "Current Account",
    reference: "SBI6789012345",
    status: "Active",
    bank: "State Bank of India",
    branch: "Chennai Mount Road",
    currency: "INR",
    openDate: "2021-09-24",
    balance: 9500000, // ₹95 lakh
    avgBalance: 9000000, // ₹90 lakh
    minBalance: 250000, // ₹2.5 lakh
    accountType: "Gold Current",
    signatories: ["Ramesh Iyer", "Lakshmi Narayanan"],
    autoSweep: true,
    cashflows: {
      "day-1": 9600000,
      "day-3": 9550000,
      "day-7": 9500000,
      "day-15": 9400000,
      "day-30": 9300000,
      "month-1": 9300000,
      "month-3": 8000000,
      "month-6": 7000000,
      "month-12": 6000000,
      "month-24": 5000000
    }
  },
  {
    id: "ca-105",
    name: "Kotak Bank Current Account",
    type: "Current Account",
    reference: "KOTAK7890123456",
    status: "Active",
    bank: "Kotak Mahindra Bank",
    branch: "Pune FC Road",
    currency: "INR",
    openDate: "2022-07-11",
    balance: 2500000, // ₹25 lakh
    avgBalance: 2400000, // ₹24 lakh
    minBalance: 100000, // ₹1 lakh
    accountType: "Edge Current",
    signatories: ["Anjali Desai", "Sandeep Mehta"],
    autoSweep: false,
    cashflows: {
      "day-1": 2600000,
      "day-3": 2550000,
      "day-7": 2500000,
      "day-15": 2450000,
      "day-30": 2400000,
      "month-1": 2400000,
      "month-3": 2000000,
      "month-6": 1700000,
      "month-12": 1500000,
      "month-24": 1200000
    }
  }
];

// 2. Savings Accounts - Sample detailed accounts
export const savingsAccountContracts = [
  {
    id: "sa-101",
    name: "HDFC Bank Savings Account",
    type: "Savings Account",
    reference: "HDFC9012345678",
    status: "Active",
    bank: "HDFC Bank",
    branch: "Mumbai Andheri",
    currency: "INR",
    openDate: "2021-03-22",
    balance: 28000000, // ₹2.8 crore
    avgBalance: 26500000, // ₹2.65 crore
    interestRate: 3.5,
    accountType: "Privilege Savings",
    signatories: ["Amit Shah", "Priya Patel"],
    autoSweep: true,
    cashflows: {
      "day-1": 28500000,
      "day-3": 28300000,
      "day-7": 28100000,
      "day-15": 28000000,
      "day-30": 27800000,
      "month-1": 27800000,
      "month-3": 25500000,
      "month-6": 23500000,
      "month-12": 21500000,
      "month-24": 19500000
    }
  },
  {
    id: "sa-102",
    name: "ICICI Bank Savings Account",
    type: "Savings Account",
    reference: "ICICI0123456789",
    status: "Active",
    bank: "ICICI Bank",
    branch: "Delhi Connaught Place",
    currency: "INR",
    openDate: "2020-09-15",
    balance: 16000000, // ₹1.6 crore
    avgBalance: 15500000, // ₹1.55 crore
    interestRate: 3.6,
    accountType: "Corporate Salary",
    signatories: ["Rahul Sharma", "Neha Gupta"],
    autoSweep: true,
    cashflows: {
      "day-1": 16200000,
      "day-3": 16100000,
      "day-7": 16000000,
      "day-15": 15800000,
      "day-30": 15700000,
      "month-1": 15700000,
      "month-3": 14500000,
      "month-6": 13500000,
      "month-12": 12500000,
      "month-24": 11500000
    }
  },
  {
    id: "sa-103",
    name: "Axis Bank Savings Account",
    type: "Savings Account",
    reference: "AXIS1234567890",
    status: "Active",
    bank: "Axis Bank",
    branch: "Bangalore MG Road",
    currency: "INR",
    openDate: "2022-01-08",
    balance: 11000000, // ₹1.1 crore
    avgBalance: 10500000, // ₹1.05 crore
    interestRate: 3.25,
    accountType: "Priority Savings",
    signatories: ["Suresh Kumar", "Vijay Reddy"],
    autoSweep: false,
    cashflows: {
      "day-1": 11200000,
      "day-3": 11100000,
      "day-7": 11000000,
      "day-15": 10900000,
      "day-30": 10800000,
      "month-1": 10800000,
      "month-3": 10000000,
      "month-6": 9000000,
      "month-12": 8000000,
      "month-24": 7000000
    }
  },
  {
    id: "sa-104",
    name: "SBI Savings Account",
    type: "Savings Account",
    reference: "SBI2345678901",
    status: "Active",
    bank: "State Bank of India",
    branch: "Chennai T Nagar",
    currency: "INR",
    openDate: "2021-11-12",
    balance: 7500000, // ₹75 lakh
    avgBalance: 7200000, // ₹72 lakh
    interestRate: 3.0,
    accountType: "Business Savings",
    signatories: ["Ramesh Iyer", "Lakshmi Narayanan"],
    autoSweep: true,
    cashflows: {
      "day-1": 7600000,
      "day-3": 7550000,
      "day-7": 7500000,
      "day-15": 7400000,
      "day-30": 7300000,
      "month-1": 7300000,
      "month-3": 6700000,
      "month-6": 6000000,
      "month-12": 5500000,
      "month-24": 5000000
    }
  },
  {
    id: "sa-105",
    name: "Kotak Bank Savings Account",
    type: "Savings Account",
    reference: "KOTAK3456789012",
    status: "Active",
    bank: "Kotak Mahindra Bank",
    branch: "Pune Camp",
    currency: "INR",
    openDate: "2022-05-21",
    balance: 2500000, // ₹25 lakh
    avgBalance: 2300000, // ₹23 lakh
    interestRate: 3.75,
    accountType: "Pro Savings",
    signatories: ["Anjali Desai", "Sandeep Mehta"],
    autoSweep: false,
    cashflows: {
      "day-1": 2500000,
      "day-3": 2450000,
      "day-7": 2400000,
      "day-15": 2350000,
      "day-30": 2300000,
      "month-1": 2300000,
      "month-3": 2100000,
      "month-6": 1900000,
      "month-12": 1700000,
      "month-24": 1500000
    }
  }
];

// 3. Corporate FDs - Sample detailed fixed deposits
export const corporateFDContracts = [
  {
    id: "cfd-101",
    name: "Bajaj Finance FD",
    type: "Fixed Deposit",
    reference: "BJFIN7654321",
    status: "Active",
    institution: "Bajaj Finance Ltd",
    currency: "INR",
    startDate: "2022-08-15",
    maturityDate: "2024-08-15",
    principal: 50000000, // ₹5 crore
    interestRate: 7.15,
    interestPayoutFrequency: "Quarterly",
    compounding: true,
    autoRenewal: false,
    rating: "AAA/CRISIL",
    lockedIn: true,
    cashflows: {
      "day-1": 50000000,
      "day-3": 50000000,
      "day-7": 50000000,
      "day-15": 50000000,
      "day-30": 50000000,
      "month-1": 50000000,
      "month-3": 50888889, // Quarterly interest added
      "month-6": 51777778, // Interest accrual
      "month-12": 53555556, // Interest accrual
      "month-24": 0 // Matured by this time
    }
  },
  {
    id: "cfd-102",
    name: "HDFC Ltd Corporate Deposit",
    type: "Fixed Deposit",
    reference: "HDFCL8765432",
    status: "Active",
    institution: "HDFC Limited",
    currency: "INR",
    startDate: "2023-03-10",
    maturityDate: "2025-03-10",
    principal: 40000000, // ₹4 crore
    interestRate: 7.35,
    interestPayoutFrequency: "Annual",
    compounding: true,
    autoRenewal: true,
    rating: "AAA/ICRA",
    lockedIn: true,
    cashflows: {
      "day-1": 40000000,
      "day-3": 40000000,
      "day-7": 40000000,
      "day-15": 40000000,
      "day-30": 40000000,
      "month-1": 40000000,
      "month-3": 40735000, // Interest accrual
      "month-6": 41470000, // Interest accrual
      "month-12": 42940000, // Annual interest
      "month-24": 45880000 // Maturing
    }
  },
  {
    id: "cfd-103",
    name: "LIC Housing Finance Deposit",
    type: "Fixed Deposit",
    reference: "LICHFL9876543",
    status: "Active",
    institution: "LIC Housing Finance",
    currency: "INR",
    startDate: "2022-11-22",
    maturityDate: "2025-11-22",
    principal: 30000000, // ₹3 crore
    interestRate: 7.40,
    interestPayoutFrequency: "Half-yearly",
    compounding: true,
    autoRenewal: false,
    rating: "AAA/CARE",
    lockedIn: false,
    cashflows: {
      "day-1": 30000000,
      "day-3": 30000000,
      "day-7": 30000000,
      "day-15": 30000000,
      "day-30": 30000000,
      "month-1": 30000000,
      "month-3": 30555000, // Interest accrual
      "month-6": 31110000, // Half-yearly interest
      "month-12": 32220000, // Interest accrual
      "month-24": 34440000 // Interest accrual
    }
  },
  {
    id: "cfd-104",
    name: "Shriram Transport Finance FD",
    type: "Fixed Deposit",
    reference: "STFC0987654",
    status: "Active",
    institution: "Shriram Transport Finance",
    currency: "INR",
    startDate: "2023-01-15",
    maturityDate: "2025-01-15",
    principal: 25000000, // ₹2.5 crore
    interestRate: 7.85,
    interestPayoutFrequency: "Monthly",
    compounding: false,
    autoRenewal: true,
    rating: "AA+/ICRA",
    lockedIn: false,
    cashflows: {
      "day-1": 25000000,
      "day-3": 25000000,
      "day-7": 25000000,
      "day-15": 25000000,
      "day-30": 25000000,
      "month-1": 25163542, // Monthly interest
      "month-3": 25490625, // Interest accrual
      "month-6": 25981250, // Interest accrual
      "month-12": 26962500, // Interest accrual
      "month-24": 0 // Matured by this time
    }
  },
  {
    id: "cfd-105",
    name: "Tata Capital Fixed Deposit",
    type: "Fixed Deposit",
    reference: "TATA7654321",
    status: "Active",
    institution: "Tata Capital",
    currency: "INR",
    startDate: "2023-05-05",
    maturityDate: "2025-05-05",
    principal: 30000000, // ₹3 crore
    interestRate: 7.60,
    interestPayoutFrequency: "Quarterly",
    compounding: true,
    autoRenewal: false,
    rating: "AAA/CRISIL",
    lockedIn: true,
    cashflows: {
      "day-1": 30000000,
      "day-3": 30000000,
      "day-7": 30000000,
      "day-15": 30000000,
      "day-30": 30000000,
      "month-1": 30000000,
      "month-3": 30570000, // Quarterly interest
      "month-6": 31140000, // Interest accrual
      "month-12": 32280000, // Interest accrual
      "month-24": 34560000 // Interest accrual
    }
  }
];

// 4. Certificate of Deposits - Sample detailed CDs
export const certificateDepositContracts = [
  {
    id: "cd-101",
    name: "SBI CD - 6 Month",
    type: "Fixed Deposit",
    reference: "SBI-CD-6M-2023",
    status: "Active",
    institution: "State Bank of India",
    currency: "INR",
    startDate: "2023-04-15",
    maturityDate: "2023-10-15",
    principal: 25000000, // ₹2.5 crore
    interestRate: 6.25,
    discountedValue: 24240000, // ₹2.424 crore 
    faceValue: 25000000, // ₹2.5 crore
    interestPayoutFrequency: "Maturity",
    tradable: true,
    rating: "A1+/CRISIL",
    cashflows: {
      "day-1": 24240000,
      "day-3": 24270000,
      "day-7": 24320000,
      "day-15": 24400000,
      "day-30": 24550000,
      "month-1": 24550000,
      "month-3": 24775000, // Time value increase
      "month-6": 0, // Matured by this time
      "month-12": 0,
      "month-24": 0
    }
  },
  {
    id: "cd-102",
    name: "HDFC Bank CD - 3 Month",
    type: "Fixed Deposit",
    reference: "HDFC-CD-3M-2023",
    status: "Active",
    institution: "HDFC Bank",
    currency: "INR",
    startDate: "2023-06-10",
    maturityDate: "2023-09-10",
    principal: 20000000, // ₹2 crore
    interestRate: 6.15,
    discountedValue: 19700000, // ₹1.97 crore
    faceValue: 20000000, // ₹2 crore
    interestPayoutFrequency: "Maturity",
    tradable: true,
    rating: "A1+/ICRA",
    cashflows: {
      "day-1": 19700000,
      "day-3": 19720000,
      "day-7": 19750000,
      "day-15": 19800000,
      "day-30": 19900000,
      "month-1": 19900000,
      "month-3": 0, // Matured by this time
      "month-6": 0,
      "month-12": 0,
      "month-24": 0
    }
  },
  {
    id: "cd-103",
    name: "ICICI Bank CD - 9 Month",
    type: "Fixed Deposit",
    reference: "ICICI-CD-9M-2023",
    status: "Active",
    institution: "ICICI Bank",
    currency: "INR",
    startDate: "2023-03-01",
    maturityDate: "2023-12-01",
    principal: 30000000, // ₹3 crore
    interestRate: 6.40,
    discountedValue: 28800000, // ₹2.88 crore
    faceValue: 30000000, // ₹3 crore
    interestPayoutFrequency: "Maturity",
    tradable: true,
    rating: "A1+/CARE",
    cashflows: {
      "day-1": 29500000,
      "day-3": 29520000,
      "day-7": 29550000,
      "day-15": 29600000,
      "day-30": 29650000,
      "month-1": 29650000,
      "month-3": 29800000, // Time value increase
      "month-6": 29900000, // Time value increase
      "month-12": 0, // Matured by this time
      "month-24": 0
    }
  },
  {
    id: "cd-104",
    name: "Axis Bank CD - 1 Year",
    type: "Fixed Deposit",
    reference: "AXIS-CD-1Y-2022",
    status: "Active",
    institution: "Axis Bank",
    currency: "INR",
    startDate: "2022-09-15",
    maturityDate: "2023-09-15",
    principal: 25000000, // ₹2.5 crore
    interestRate: 6.60,
    discountedValue: 23500000, // ₹2.35 crore
    faceValue: 25000000, // ₹2.5 crore
    interestPayoutFrequency: "Maturity",
    tradable: true,
    rating: "A1+/ICRA",
    cashflows: {
      "day-1": 24850000,
      "day-3": 24860000,
      "day-7": 24870000,
      "day-15": 24880000,
      "day-30": 24900000,
      "month-1": 24900000,
      "month-3": 0, // Matured by this time
      "month-6": 0, 
      "month-12": 0,
      "month-24": 0
    }
  },
  {
    id: "cd-105",
    name: "Yes Bank CD - 6 Month",
    type: "Fixed Deposit",
    reference: "YES-CD-6M-2023",
    status: "Active",
    institution: "Yes Bank",
    currency: "INR",
    startDate: "2023-05-20",
    maturityDate: "2023-11-20",
    principal: 15000000, // ₹1.5 crore
    interestRate: 6.75,
    discountedValue: 14500000, // ₹1.45 crore
    faceValue: 15000000, // ₹1.5 crore
    interestPayoutFrequency: "Maturity",
    tradable: true,
    rating: "A1/CRISIL",
    cashflows: {
      "day-1": 14700000,
      "day-3": 14720000,
      "day-7": 14750000,
      "day-15": 14780000,
      "day-30": 14820000,
      "month-1": 14820000,
      "month-3": 14910000, // Time value increase
      "month-6": 15000000, // Maturing value
      "month-12": 0, 
      "month-24": 0
    }
  }
];

// 5. Vehicle Loans - Sample detailed vehicle loans
export const vehicleLoanContracts = [
  {
    id: "vl-101",
    name: "Commercial Vehicle Fleet - Shree Transport",
    type: "Loan Asset",
    reference: "VL-ST-2022-001",
    status: "Active",
    borrower: "Shree Transport Services",
    currency: "INR",
    disbursementDate: "2022-07-10",
    maturityDate: "2027-07-10",
    principal: 150000000, // ₹15 crore
    outstandingPrincipal: 135000000, // ₹13.5 crore
    interestRate: 12.5, // Commercial vehicle loans have higher rates
    loanType: "Commercial Vehicle Fleet",
    collateral: "10 Trucks (TATA & Ashok Leyland)",
    repaymentFrequency: "Monthly",
    emiAmount: 3350000, // ₹33.5 lakh
    performingStatus: "Standard",
    cashflows: {
      "day-1": 135000000, // Outstanding principal
      "day-3": 135000000,
      "day-7": 135000000,
      "day-15": 135000000,
      "day-30": 134200000, // Principal reduction after EMI
      "month-1": 134200000,
      "month-3": 132600000, // Principal reduction after 3 EMIs
      "month-6": 130000000, // Principal reduction after 6 EMIs
      "month-12": 125000000, // Principal reduction after 12 EMIs
      "month-24": 114000000 // Principal reduction after 24 EMIs
    }
  },
  {
    id: "vl-102",
    name: "Truck Loan - Bharat Logistics",
    type: "Loan Asset",
    reference: "VL-BL-2022-034",
    status: "Active",
    borrower: "Bharat Logistics Pvt Ltd",
    currency: "INR",
    disbursementDate: "2022-09-15",
    maturityDate: "2026-09-15",
    principal: 85000000, // ₹8.5 crore
    outstandingPrincipal: 78000000, // ₹7.8 crore
    interestRate: 12.75,
    loanType: "Heavy Commercial Vehicle",
    collateral: "5 Trucks (TATA Prima)",
    repaymentFrequency: "Monthly",
    emiAmount: 2400000, // ₹24 lakh
    performingStatus: "Standard",
    cashflows: {
      "day-1": 78000000, // Outstanding principal
      "day-3": 78000000,
      "day-7": 78000000,
      "day-15": 78000000,
      "day-30": 77500000, // Principal reduction after EMI
      "month-1": 77500000,
      "month-3": 76500000, // Principal reduction after 3 EMIs
      "month-6": 75000000, // Principal reduction after 6 EMIs
      "month-12": 72000000, // Principal reduction after 12 EMIs
      "month-24": 65000000 // Principal reduction after 24 EMIs
    }
  },
  {
    id: "vl-103",
    name: "Car Fleet - Metro Cab Services",
    type: "Loan Asset",
    reference: "VL-MCS-2023-012",
    status: "Active",
    borrower: "Metro Cab Services",
    currency: "INR",
    disbursementDate: "2023-01-20",
    maturityDate: "2026-01-20",
    principal: 120000000, // ₹12 crore
    outstandingPrincipal: 115000000, // ₹11.5 crore
    interestRate: 11.8,
    loanType: "Commercial Car Fleet",
    collateral: "30 Cars (Maruti Swift Dzire)",
    repaymentFrequency: "Monthly",
    emiAmount: 3950000, // ₹39.5 lakh
    performingStatus: "Standard",
    cashflows: {
      "day-1": 115000000, // Outstanding principal
      "day-3": 115000000,
      "day-7": 115000000,
      "day-15": 115000000,
      "day-30": 114400000, // Principal reduction after EMI
      "month-1": 114400000,
      "month-3": 113200000, // Principal reduction after 3 EMIs
      "month-6": 111500000, // Principal reduction after 6 EMIs
      "month-12": 108000000, // Principal reduction after 12 EMIs
      "month-24": 100000000 // Principal reduction after 24 EMIs
    }
  },
  {
    id: "vl-104",
    name: "Bus Fleet - Samarth Travels",
    type: "Loan Asset",
    reference: "VL-ST-2022-089",
    status: "Active",
    borrower: "Samarth Travels Pvt Ltd",
    currency: "INR",
    disbursementDate: "2022-11-05",
    maturityDate: "2027-11-05",
    principal: 180000000, // ₹18 crore
    outstandingPrincipal: 170000000, // ₹17 crore
    interestRate: 12.9,
    loanType: "Tourist Bus Fleet",
    collateral: "12 Buses (Volvo & Mercedes)",
    repaymentFrequency: "Monthly",
    emiAmount: 4100000, // ₹41 lakh
    performingStatus: "Standard",
    cashflows: {
      "day-1": 170000000, // Outstanding principal
      "day-3": 170000000,
      "day-7": 170000000,
      "day-15": 170000000,
      "day-30": 169200000, // Principal reduction after EMI
      "month-1": 169200000,
      "month-3": 167600000, // Principal reduction after 3 EMIs
      "month-6": 165000000, // Principal reduction after 6 EMIs
      "month-12": 160000000, // Principal reduction after 12 EMIs
      "month-24": 145000000 // Principal reduction after 24 EMIs
    }
  },
  {
    id: "vl-105",
    name: "Tractor Loans Portfolio",
    type: "Loan Asset",
    reference: "VL-TRAC-2022-055",
    status: "Active",
    borrower: "Various - Agriculture Sector",
    currency: "INR",
    disbursementDate: "2022-04-01",
    maturityDate: "2027-04-01",
    principal: 85000000, // ₹8.5 crore
    outstandingPrincipal: 75000000, // ₹7.5 crore
    interestRate: 12.25,
    loanType: "Tractor Financing",
    collateral: "85 Tractors (Various Brands)",
    repaymentFrequency: "Quarterly",
    emiAmount: 6200000, // ₹62 lakh quarterly
    performingStatus: "Standard",
    cashflows: {
      "day-1": 75000000, // Outstanding principal
      "day-3": 75000000,
      "day-7": 75000000,
      "day-15": 75000000,
      "day-30": 75000000, 
      "month-1": 75000000,
      "month-3": 73800000, // Principal reduction after quarterly EMI
      "month-6": 72600000, // Principal reduction after 2 quarterly EMIs
      "month-12": 70000000, // Principal reduction after 4 quarterly EMIs
      "month-24": 65000000 // Principal reduction after 8 quarterly EMIs
    }
  }
];

// 6. Personal Loans - Sample detailed personal loans
export const personalLoanContracts = [
  {
    id: "pl-101",
    name: "Salaried Professional Loans - Tranche 1",
    type: "Loan Asset",
    reference: "PL-SP-2022-Q1",
    status: "Active",
    borrower: "Various - Corporate Employees",
    currency: "INR",
    disbursementDate: "2022-03-15",
    maturityDate: "2025-03-15",
    principal: 75000000, // ₹7.5 crore
    outstandingPrincipal: 60000000, // ₹6 crore
    interestRate: 14.0,
    loanType: "Personal Loan - Salaried",
    collateral: "Unsecured",
    repaymentFrequency: "Monthly",
    averageEmi: 2620000, // ₹26.2 lakh combined EMIs
    noOfAccounts: 950,
    averageTenure: 36, // months
    performingStatus: "Standard",
    cashflows: {
      "day-1": 60000000, // Outstanding principal
      "day-3": 60000000,
      "day-7": 60000000,
      "day-15": 60000000,
      "day-30": 59400000, // Principal reduction after EMIs
      "month-1": 59400000,
      "month-3": 58200000, // Principal reduction after 3 months
      "month-6": 56500000, // Principal reduction after 6 months
      "month-12": 53000000, // Principal reduction after 12 months
      "month-24": 46000000 // Principal reduction after 24 months
    }
  },
  {
    id: "pl-102",
    name: "Self-employed Professionals - Tranche 2",
    type: "Loan Asset",
    reference: "PL-SEP-2022-Q2",
    status: "Active",
    borrower: "Various - Self Employed",
    currency: "INR",
    disbursementDate: "2022-06-01",
    maturityDate: "2025-06-01",
    principal: 60000000, // ₹6 crore
    outstandingPrincipal: 52000000, // ₹5.2 crore
    interestRate: 15.5,
    loanType: "Personal Loan - Self Employed",
    collateral: "Unsecured",
    repaymentFrequency: "Monthly",
    averageEmi: 2100000, // ₹21 lakh combined EMIs
    noOfAccounts: 720,
    averageTenure: 36, // months
    performingStatus: "Standard",
    cashflows: {
      "day-1": 52000000, // Outstanding principal
      "day-3": 52000000,
      "day-7": 52000000,
      "day-15": 52000000,
      "day-30": 51400000, // Principal reduction after EMIs
      "month-1": 51400000,
      "month-3": 50200000, // Principal reduction after 3 months
      "month-6": 48500000, // Principal reduction after 6 months
      "month-12": 45000000, // Principal reduction after 12 months
      "month-24": 38000000 // Principal reduction after 24 months
    }
  },
  {
    id: "pl-103",
    name: "Corporate Employee Program - Tech Companies",
    type: "Loan Asset",
    reference: "PL-CORP-TECH-2023",
    status: "Active",
    borrower: "Various - IT Sector",
    currency: "INR",
    disbursementDate: "2023-01-10",
    maturityDate: "2026-01-10",
    principal: 85000000, // ₹8.5 crore
    outstandingPrincipal: 80000000, // ₹8 crore
    interestRate: 13.25,
    loanType: "Personal Loan - Corporate Program",
    collateral: "Unsecured",
    repaymentFrequency: "Monthly",
    averageEmi: 2900000, // ₹29 lakh combined EMIs
    noOfAccounts: 1100,
    averageTenure: 36, // months
    performingStatus: "Standard",
    cashflows: {
      "day-1": 80000000, // Outstanding principal
      "day-3": 80000000,
      "day-7": 80000000,
      "day-15": 80000000,
      "day-30": 79300000, // Principal reduction after EMIs
      "month-1": 79300000,
      "month-3": 77900000, // Principal reduction after 3 months
      "month-6": 76000000, // Principal reduction after 6 months
      "month-12": 72000000, // Principal reduction after 12 months
      "month-24": 64000000 // Principal reduction after 24 months
    }
  },
  {
    id: "pl-104",
    name: "Public Sector Employees Program",
    type: "Loan Asset",
    reference: "PL-PSE-2022-Q4",
    status: "Active",
    borrower: "Various - Govt Sector",
    currency: "INR",
    disbursementDate: "2022-10-20",
    maturityDate: "2027-10-20",
    principal: 40000000, // ₹4 crore
    outstandingPrincipal: 37000000, // ₹3.7 crore
    interestRate: 12.75,
    loanType: "Personal Loan - Govt Employees",
    collateral: "Unsecured",
    repaymentFrequency: "Monthly",
    averageEmi: 900000, // ₹9 lakh combined EMIs
    noOfAccounts: 650,
    averageTenure: 60, // months
    performingStatus: "Standard",
    cashflows: {
      "day-1": 37000000, // Outstanding principal
      "day-3": 37000000,
      "day-7": 37000000,
      "day-15": 37000000,
      "day-30": 36700000, // Principal reduction after EMIs
      "month-1": 36700000,
      "month-3": 36100000, // Principal reduction after 3 months
      "month-6": 35300000, // Principal reduction after 6 months
      "month-12": 33700000, // Principal reduction after 12 months
      "month-24": 30500000 // Principal reduction after 24 months
    }
  },
  {
    id: "pl-105",
    name: "Healthcare Professional Loans",
    type: "Loan Asset",
    reference: "PL-HEALTH-2022",
    status: "Active",
    borrower: "Various - Medical Professionals",
    currency: "INR",
    disbursementDate: "2022-07-05",
    maturityDate: "2027-07-05",
    principal: 50000000, // ₹5 crore
    outstandingPrincipal: 47000000, // ₹4.7 crore
    interestRate: 13.0,
    loanType: "Personal Loan - Healthcare",
    collateral: "Unsecured",
    repaymentFrequency: "Monthly",
    averageEmi: 1150000, // ₹11.5 lakh combined EMIs
    noOfAccounts: 420,
    averageTenure: 60, // months
    performingStatus: "Standard",
    cashflows: {
      "day-1": 47000000, // Outstanding principal
      "day-3": 47000000,
      "day-7": 47000000,
      "day-15": 47000000,
      "day-30": 46650000, // Principal reduction after EMIs
      "month-1": 46650000,
      "month-3": 45950000, // Principal reduction after 3 months
      "month-6": 44900000, // Principal reduction after 6 months
      "month-12": 42800000, // Principal reduction after 12 months
      "month-24": 38500000 // Principal reduction after 24 months
    }
  }
];

// 7. SME Loans - Sample detailed SME loans
export const smeLoanContracts = [
  {
    id: "sme-101",
    name: "Manufacturing SME Loan Portfolio",
    type: "Loan Asset",
    reference: "SME-MFG-2022-001",
    status: "Active",
    borrower: "Various - Manufacturing Sector",
    currency: "INR",
    disbursementDate: "2022-05-15",
    maturityDate: "2027-05-15",
    principal: 80000000, // ₹8 crore
    outstandingPrincipal: 72000000, // ₹7.2 crore
    interestRate: 13.5,
    loanType: "Term Loan - Manufacturing",
    collateral: "Machinery & Equipment",
    repaymentFrequency: "Monthly",
    averageEmi: 1850000, // ₹18.5 lakh combined EMIs
    noOfAccounts: 38,
    avgLoanSize: 2105000, // ₹21.05 lakh
    performingStatus: "Standard",
    cashflows: {
      "day-1": 72000000, // Outstanding principal
      "day-3": 72000000,
      "day-7": 72000000,
      "day-15": 72000000,
      "day-30": 71500000, // Principal reduction after EMIs
      "month-1": 71500000,
      "month-3": 70500000, // Principal reduction after 3 months
      "month-6": 69000000, // Principal reduction after 6 months
      "month-12": 66000000, // Principal reduction after 12 months
      "month-24": 60000000 // Principal reduction after 24 months
    }
  },
  {
    id: "sme-102",
    name: "Retail Services SME Loan Portfolio",
    type: "Loan Asset",
    reference: "SME-RET-2022-045",
    status: "Active",
    borrower: "Various - Retail Sector",
    currency: "INR",
    disbursementDate: "2022-08-10",
    maturityDate: "2026-08-10",
    principal: 60000000, // ₹6 crore
    outstandingPrincipal: 54000000, // ₹5.4 crore
    interestRate: 14.0,
    loanType: "Term Loan - Retail Services",
    collateral: "Commercial Property & Inventory",
    repaymentFrequency: "Monthly",
    averageEmi: 1650000, // ₹16.5 lakh combined EMIs
    noOfAccounts: 55,
    avgLoanSize: 1090000, // ₹10.9 lakh
    performingStatus: "Standard",
    cashflows: {
      "day-1": 54000000, // Outstanding principal
      "day-3": 54000000,
      "day-7": 54000000,
      "day-15": 54000000,
      "day-30": 53600000, // Principal reduction after EMIs
      "month-1": 53600000,
      "month-3": 52800000, // Principal reduction after 3 months
      "month-6": 51500000, // Principal reduction after 6 months
      "month-12": 49000000, // Principal reduction after 12 months
      "month-24": 44000000 // Principal reduction after 24 months
    }
  },
  {
    id: "sme-103",
    name: "IT Services SME Loan Portfolio",
    type: "Loan Asset",
    reference: "SME-IT-2023-012",
    status: "Active",
    borrower: "Various - IT Services",
    currency: "INR",
    disbursementDate: "2023-01-25",
    maturityDate: "2028-01-25",
    principal: 55000000, // ₹5.5 crore
    outstandingPrincipal: 53500000, // ₹5.35 crore
    interestRate: 12.75,
    loanType: "Term Loan - IT Services",
    collateral: "Office Equipment & Guarantees",
    repaymentFrequency: "Monthly",
    averageEmi: 1250000, // ₹12.5 lakh combined EMIs
    noOfAccounts: 22,
    avgLoanSize: 2500000, // ₹25 lakh
    performingStatus: "Standard",
    cashflows: {
      "day-1": 53500000, // Outstanding principal
      "day-3": 53500000,
      "day-7": 53500000,
      "day-15": 53500000,
      "day-30": 53100000, // Principal reduction after EMIs
      "month-1": 53100000,
      "month-3": 52300000, // Principal reduction after 3 months
      "month-6": 51100000, // Principal reduction after 6 months
      "month-12": 48700000, // Principal reduction after 12 months
      "month-24": 43900000 // Principal reduction after 24 months
    }
  },
  {
    id: "sme-104",
    name: "Healthcare SME Loan Portfolio",
    type: "Loan Asset",
    reference: "SME-HC-2022-089",
    status: "Active",
    borrower: "Various - Healthcare Services",
    currency: "INR",
    disbursementDate: "2022-11-10",
    maturityDate: "2027-11-10",
    principal: 45000000, // ₹4.5 crore
    outstandingPrincipal: 42500000, // ₹4.25 crore
    interestRate: 13.0,
    loanType: "Term Loan - Healthcare",
    collateral: "Medical Equipment & Property",
    repaymentFrequency: "Monthly",
    averageEmi: 1050000, // ₹10.5 lakh combined EMIs
    noOfAccounts: 18,
    avgLoanSize: 2500000, // ₹25 lakh
    performingStatus: "Standard",
    cashflows: {
      "day-1": 42500000, // Outstanding principal
      "day-3": 42500000,
      "day-7": 42500000,
      "day-15": 42500000,
      "day-30": 42200000, // Principal reduction after EMIs
      "month-1": 42200000,
      "month-3": 41500000, // Principal reduction after 3 months
      "month-6": 40500000, // Principal reduction after 6 months
      "month-12": 38500000, // Principal reduction after 12 months
      "month-24": 34500000 // Principal reduction after 24 months
    }
  },
  {
    id: "sme-105",
    name: "Restaurant & Food Services Loans",
    type: "Loan Asset",
    reference: "SME-FOOD-2022-055",
    status: "Active",
    borrower: "Various - F&B Sector",
    currency: "INR",
    disbursementDate: "2022-09-01",
    maturityDate: "2026-09-01",
    principal: 30000000, // ₹3 crore
    outstandingPrincipal: 27000000, // ₹2.7 crore
    interestRate: 14.5,
    loanType: "Term Loan - F&B",
    collateral: "Commercial Kitchen Equipment & Property",
    repaymentFrequency: "Monthly",
    averageEmi: 850000, // ₹8.5 lakh combined EMIs
    noOfAccounts: 25,
    avgLoanSize: 1200000, // ₹12 lakh
    performingStatus: "Standard",
    cashflows: {
      "day-1": 27000000, // Outstanding principal
      "day-3": 27000000,
      "day-7": 27000000,
      "day-15": 27000000,
      "day-30": 26700000, // Principal reduction after EMIs
      "month-1": 26700000,
      "month-3": 26100000, // Principal reduction after 3 months
      "month-6": 25200000, // Principal reduction after 6 months
      "month-12": 23400000, // Principal reduction after 12 months
      "month-24": 20000000 // Principal reduction after 24 months
    }
  }
];

// 8. Gold Loans - Sample detailed gold loans
export const goldLoanContracts = [
  {
    id: "gl-101",
    name: "Gold Loan Portfolio - Urban",
    type: "Loan Asset",
    reference: "GL-URB-2022-Q1",
    status: "Active",
    borrower: "Various - Urban Clients",
    currency: "INR",
    disbursementDate: "2022-03-01",
    maturityDate: "2024-03-01",
    principal: 60000000, // ₹6 crore
    outstandingPrincipal: 55000000, // ₹5.5 crore
    interestRate: 11.5,
    loanType: "Gold Loan - Urban",
    collateral: "Gold Jewelry & Coins (1,215 items)",
    LTV: 65, // Loan to Value percentage
    goldWeightInGrams: 120000, // 120 KG total
    repaymentFrequency: "Monthly Interest, Bullet Principal",
    interestAmount: 529000, // ₹5.29 lakh monthly interest
    noOfAccounts: 850,
    avgLoanSize: 70588, // ₹70,588
    performingStatus: "Standard",
    cashflows: {
      "day-1": 55000000, // Outstanding principal
      "day-3": 55000000,
      "day-7": 55000000,
      "day-15": 55000000,
      "day-30": 55000000, // Only interest paid, principal remains
      "month-1": 55000000,
      "month-3": 55000000, // Only interest paid, principal remains
      "month-6": 55000000, // Only interest paid, principal remains
      "month-12": 50000000, // Some prepayments expected
      "month-24": 0 // Matured by this time
    }
  },
  {
    id: "gl-102",
    name: "Gold Loan Portfolio - Rural",
    type: "Loan Asset",
    reference: "GL-RUR-2022-Q2",
    status: "Active",
    borrower: "Various - Rural Clients",
    currency: "INR",
    disbursementDate: "2022-06-15",
    maturityDate: "2024-06-15",
    principal: 45000000, // ₹4.5 crore
    outstandingPrincipal: 42000000, // ₹4.2 crore
    interestRate: 12.0,
    loanType: "Gold Loan - Rural",
    collateral: "Gold Jewelry (2,100 items)",
    LTV: 60, // Loan to Value percentage
    goldWeightInGrams: 95000, // 95 KG total
    repaymentFrequency: "Monthly Interest, Bullet Principal",
    interestAmount: 420000, // ₹4.2 lakh monthly interest
    noOfAccounts: 1400,
    avgLoanSize: 32143, // ₹32,143
    performingStatus: "Standard",
    cashflows: {
      "day-1": 42000000, // Outstanding principal
      "day-3": 42000000,
      "day-7": 42000000,
      "day-15": 42000000,
      "day-30": 42000000, // Only interest paid, principal remains
      "month-1": 42000000,
      "month-3": 42000000, // Only interest paid, principal remains
      "month-6": 42000000, // Only interest paid, principal remains
      "month-12": 38000000, // Some prepayments expected
      "month-24": 0 // Matured by this time
    }
  },
  {
    id: "gl-103",
    name: "Gold Loan Portfolio - High Value",
    type: "Loan Asset",
    reference: "GL-HV-2022-Q3",
    status: "Active",
    borrower: "Various - HNI Clients",
    currency: "INR",
    disbursementDate: "2022-08-10",
    maturityDate: "2024-08-10",
    principal: 35000000, // ₹3.5 crore
    outstandingPrincipal: 33000000, // ₹3.3 crore
    interestRate: 11.0,
    loanType: "Gold Loan - Premium",
    collateral: "Gold Bullion & Coins (380 items)",
    LTV: 70, // Loan to Value percentage
    goldWeightInGrams: 70000, // 70 KG total
    repaymentFrequency: "Monthly Interest, Bullet Principal",
    interestAmount: 302500, // ₹3.025 lakh monthly interest
    noOfAccounts: 120,
    avgLoanSize: 291667, // ₹2.92 lakh
    performingStatus: "Standard",
    cashflows: {
      "day-1": 33000000, // Outstanding principal
      "day-3": 33000000,
      "day-7": 33000000,
      "day-15": 33000000,
      "day-30": 33000000, // Only interest paid, principal remains
      "month-1": 33000000,
      "month-3": 33000000, // Only interest paid, principal remains
      "month-6": 33000000, // Only interest paid, principal remains
      "month-12": 30000000, // Some prepayments expected
      "month-24": 0 // Matured by this time
    }
  },
  {
    id: "gl-104",
    name: "Gold Loan Portfolio - Quick Loans",
    type: "Loan Asset",
    reference: "GL-QL-2022-Q4",
    status: "Active",
    borrower: "Various - Mixed Clients",
    currency: "INR",
    disbursementDate: "2022-11-20",
    maturityDate: "2023-11-20",
    principal: 25000000, // ₹2.5 crore
    outstandingPrincipal: 25000000, // ₹2.5 crore
    interestRate: 13.0,
    loanType: "Gold Loan - Short Term",
    collateral: "Gold Jewelry (950 items)",
    LTV: 65, // Loan to Value percentage
    goldWeightInGrams: 55000, // 55 KG total
    repaymentFrequency: "Monthly Interest, Bullet Principal",
    interestAmount: 270833, // ₹2.71 lakh monthly interest
    noOfAccounts: 650,
    avgLoanSize: 38461, // ₹38,461
    performingStatus: "Standard",
    cashflows: {
      "day-1": 25000000, // Outstanding principal
      "day-3": 25000000,
      "day-7": 25000000,
      "day-15": 25000000,
      "day-30": 25000000, // Only interest paid, principal remains
      "month-1": 25000000,
      "month-3": 25000000, // Only interest paid, principal remains
      "month-6": 25000000, // Only interest paid, principal remains
      "month-12": 0, // Matured by this time
      "month-24": 0 
    }
  },
  {
    id: "gl-105",
    name: "Gold Loan Portfolio - Overdraft",
    type: "Loan Asset",
    reference: "GL-OD-2023-Q1",
    status: "Active",
    borrower: "Various - Business Owners",
    currency: "INR",
    disbursementDate: "2023-01-05",
    maturityDate: "2025-01-05",
    principal: 20000000, // ₹2 crore
    outstandingPrincipal: 20000000, // ₹2 crore (fully utilized)
    interestRate: 12.5,
    loanType: "Gold Loan - OD Facility",
    collateral: "Gold Jewelry & Coins (425 items)",
    LTV: 60, // Loan to Value percentage
    goldWeightInGrams: 40000, // 40 KG total
    repaymentFrequency: "Monthly Interest, Revolving Principal",
    interestAmount: 208333, // ₹2.08 lakh monthly interest
    noOfAccounts: 180,
    avgLoanSize: 111111, // ₹1.11 lakh
    performingStatus: "Standard",
    cashflows: {
      "day-1": 20000000, // Outstanding principal
      "day-3": 20000000,
      "day-7": 20000000,
      "day-15": 20000000,
      "day-30": 20000000, // Only interest paid, principal revolving
      "month-1": 20000000,
      "month-3": 20000000, // Only interest paid, principal revolving
      "month-6": 19000000, // Some reduction in utilization
      "month-12": 18000000, // Some reduction in utilization
      "month-24": 0 // Matured by this time
    }
  }
];
